


























import { Component, Vue } from "vue-property-decorator";
import { BContainer, BRow, BCol  } from "bootstrap-vue";
import AdminOnly from '@/components/adminOnly/AdminOnly.vue';
import SentinelaReport from '@/views/sentinelaReport/SentinelaReport.vue';
import DocToCarReport from '@/views/docToCarReport/DocToCarReport.vue';
import DocToEgReport from '@/views/docToEgReport/DocToEgReport.vue';
import RiskReport from '@/views/riskReport/RiskReport.vue';

@Component ({
    name: "Toolbox",
    components: {
      SentinelaReport,
      DocToCarReport,
      DocToEgReport,
      RiskReport,
      BContainer,
      BRow,
      BCol,
      AdminOnly,
    }
})

export default class Toolbox extends Vue {}
